import React, { Component } from "react";
import { connect } from "react-redux";
import Topbar from './components/Topbar';
import Sidebar from "./components/Sidebar";
import Loading from '../../admin/components/Loading';
import { MDBDataTable } from "mdbreact";
import axios from "axios";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import { CSVLink } from "react-csv";

const mySwal = withReactContent(Swal);

class UserPerformance extends Component {
    constructor(props) {
        super(props);
        this.state = {
            toggled: false,
            data: [],
            loading: true,
            startDate: "",
            endDate: "",
            operatorId: ""
        };
    }

    componentDidMount() {
        if (!this.props.distributor || !this.props.distributor.user_performance) {
            return this.props.history.push('/distributor');
        } else {
            let sendThis = {
                operatorId: this.props.distributor.admin.map(admin => admin.id)
            }
            
            axios
                .post("/api/admin/report/user", sendThis, { headers: { "Content-Type": "application/json", "auth-token": this.props.token } })
                .then(res => {
                    this.setState({
                        ...this.state,
                        loading: false,
                        data: res.data.data
                    });
                })
                .catch(err => {
                    this.setState({
                        ...this.state,
                        loading: false
                    });
                    mySwal.fire("Error", err.response.data.error, "error");
                });
        }
    };

    handleToggle = () => this.setState({ ...this.state, toggled: !this.state.toggled });

    handleChange = e => this.setState({
        ...this.state,
        [e.target.id]: e.target.value
    });

    handleDate = dates => {
        const [start, end] = dates;
        this.setState({
            ...this.state,
            startDate: start,
            endDate: end
        });
    };

    handleFilter = e => {
        const { /*operatorId,*/ startDate, endDate } = this.state;
        // if (!operatorId) {
        //     mySwal.fire("Error", "Please select the operator", "error");
        // } else {
            let sendThis = {
                operatorId: this.props.distributor.admin.map(admin => admin.id)
            }

            if (startDate && endDate) {
                sendThis.startDate = new Date(startDate);
                sendThis.endDate = new Date(endDate).setHours(23, 59, 59, 999);
            }
            this.setState({
                ...this.state,
                loading: true
            });
            axios
                .post("/api/admin/report/user", sendThis, { headers: { "Content-Type": "application/json", "auth-token": this.props.token } })
                .then(res => {
                    this.setState({
                        ...this.state,
                        loading: false,
                        data: res.data.data
                    });
                })
                .catch(err => {
                    this.setState({
                        ...this.state,
                        loading: false
                    });
                    mySwal.fire("Error", err.response.data.error, "error");
                });
        // }
    };

    handleReset = e => {
        this.setState({
            ...this.state,
            startDate: "",
            endDate: "",
            operatorId: "",
            data: null
        });
    };

    render() {
        let data = {
            columns: [
                {
                    label: "Operator",
                    field: "operatorName",
                    sort: "asc"
                },
                {
                    label: "Name",
                    field: "userName",
                    sort: "asc"
                },
                {
                    label: "Number",
                    field: "number",
                    sort: "asc"
                },
                {
                    label: "Join Date",
                    field: "joinedDate",
                    sort: "asc"
                },
                {
                    label: "Member ID",
                    field: "memberId",
                    sort: "asc"
                },
                {
                    label: "Store",
                    field: "outlet",
                    sort: "asc"
                },
                {
                    label: "Channel",
                    field: "channel",
                    sort: "asc"
                },
                {
                    label: (
                        <OverlayTrigger
                            placement="top"
                            overlay={
                                <Tooltip>
                                    <ul>
                                        <li><b>Registered</b>: User registered but no transaction record</li>
                                        <li><b>Active</b>: User spending is less than RM50</li>
                                        <li><b>Tier 1</b>: User spending is from RM50 to RM199</li>
                                        <li><b>Tier 2</b>: User spending is RM200 and above</li>
                                    </ul>
                                </Tooltip>
                            }
                        >
                            <span>Tier</span>
                        </OverlayTrigger>
                    ),
                    field: "tier",
                    sort: "asc"
                },
                {
                    label: "Referrer",
                    field: "referrer",
                    sort: "asc"
                },
                {
                    label: "Referrals",
                    field: "referrals",
                    sort: "asc"
                },
                {
                    label: (
                        <OverlayTrigger
                            placement="top"
                            overlay={
                                <Tooltip>
                                    Number of transactions for last 7 days
                                </Tooltip>
                            }
                        >
                            <span>Number of Usage (in week)</span>
                        </OverlayTrigger>
                    ),
                    field: "weekUsage",
                    sort: "asc"
                },
                {
                    label: (
                        <OverlayTrigger
                            placement="top"
                            overlay={
                                <Tooltip>
                                    Number of transactions for last 1 month
                                </Tooltip>
                            }
                        >
                            <span>Number of Usage (in month)</span>
                        </OverlayTrigger>
                    ),
                    field: "monthUsage",
                    sort: "asc"
                },
                {
                    label: (
                        <OverlayTrigger
                            placement="top"
                            overlay={
                                <Tooltip>
                                    Total amount spent in all the transactions
                                </Tooltip>
                            }
                        >
                            <span>Total Spent (RM)</span>
                        </OverlayTrigger>
                    ),
                    field: "totalSpent",
                    sort: "asc"
                },
                {
                    label: "Last Transaction Date",
                    field: "lastTransaction",
                    sort: "asc"
                },
                {
                    label: (
                        <OverlayTrigger
                            placement="top"
                            overlay={
                                <Tooltip>
                                    Number of vouchers collected
                                </Tooltip>
                            }
                        >
                            <span>Voucher Collected</span>
                        </OverlayTrigger>
                    ),
                    field: "voucherAcquired",
                    sort: "asc"
                },
                {
                    label: (
                        <OverlayTrigger
                            placement="top"
                            overlay={
                                <Tooltip>
                                    Number of vouchers used
                                </Tooltip>
                            }
                        >
                            <span>Voucher Spent</span>
                        </OverlayTrigger>
                    ),
                    field: "voucherUsed",
                    sort: "asc"
                },
                {
                    label: (
                        <OverlayTrigger
                            placement="top"
                            overlay={
                                <Tooltip>
                                    Total number of washer machine transactions
                                </Tooltip>
                            }
                        >
                            <span>Washer Used</span>
                        </OverlayTrigger>
                    ),
                    field: "washerUsed",
                    sort: "asc"
                },
                {
                    label: (
                        <OverlayTrigger
                            placement="top"
                            overlay={
                                <Tooltip>
                                    Total number of dryer machine transactions
                                </Tooltip>
                            }
                        >
                            <span>Dryer Used</span>
                        </OverlayTrigger>
                    ),
                    field: "dryerUsed",
                    sort: "asc"
                }
            ],
            rows: this.state.data
        };

        let csv = [];

        if (this.state.data.length > 0) {
            for (let i = 0; i < this.state.data.length; i++) {
                let data = {
                    operatorName: this.state.data[i].operatorName,
                    userName: this.state.data[i].userName,
                    number: `=""${this.state.data[i].number}""`,
                    joinedDate: this.state.data[i].joinedDate,
                    memberId: this.state.data[i].memberId,
                    outlet: this.state.data[i].outlet,
                    channel: this.state.data[i].channel,
                    tier: this.state.data[i].tier,
                    referrer: this.state.data[i].referrer,
                    referrals: this.state.data[i].referrals,
                    weekUsage: this.state.data[i].weekUsage,
                    monthUsage: this.state.data[i].monthUsage,
                    totalStamps: this.state.data[i].totalStamps,
                    tokenSpent: this.state.data[i].tokenSpent,
                    totalSpent: this.state.data[i].totalSpent,
                    lastTransaction: this.state.data[i].lastTransaction,
                    voucherAcquired: this.state.data[i].voucherAcquired,
                    voucherUsed: this.state.data[i].voucherUsed,
                    washerUsed: this.state.data[i].washerUsed,
                    dryerUsed: this.state.data[i].dryerUsed
                }
                csv.push(data);
            }
        }

        const csvData = {
            headers: [
                { label: "Operator", key: "operatorName" },
                { label: "Name", key: "userName" },
                { label: "Number", key: "number" },
                { label: "Join Date", key: "joinedDate" },
                { label: "Member ID", key: "memberId" },
                { label: "Store", key: "outlet" },
                { label: "Channel", key: "channel" },
                { label: "Tier", key: "tier" },
                { label: "Referrer", key: "referrer" },
                { label: "Referrals", key: "referrals" },
                { label: "Number of Usage (in week)", key: "weekUsage" },
                { label: "Number of Usage (in month)", key: "monthUsage" },
                { label: "Total Spent (RM)", key: "totalSpent" },
                { label: "Last Transaction Date", key: "lastTransaction" },
                { label: "Voucher Collected", key: "voucherAcquired" },
                { label: "Voucher Spent", key: "voucherUsed" },
                { label: "Washer Used", key: "washerUsed" },
                { label: "Dryer Used", key: "dryerUsed" },
            ],
            data: csv
        };

        if (this.props.distributor.token) {
            data.columns = [
                {
                    label: "Operator",
                    field: "operatorName",
                    sort: "asc"
                },
                {
                    label: "Name",
                    field: "userName",
                    sort: "asc"
                },
                {
                    label: "Number",
                    field: "number",
                    sort: "asc"
                },
                {
                    label: "Join Date",
                    field: "joinedDate",
                    sort: "asc"
                },
                {
                    label: "Member ID",
                    field: "memberId",
                    sort: "asc"
                },
                {
                    label: "Store",
                    field: "outlet",
                    sort: "asc"
                },
                {
                    label: "Channel",
                    field: "channel",
                    sort: "asc"
                },
                {
                    label: (
                        <OverlayTrigger
                            placement="top"
                            overlay={
                                <Tooltip>
                                    <ul>
                                        <li><b>Registered</b>: User registered but no transaction record</li>
                                        <li><b>Active</b>: User spending is less than RM50</li>
                                        <li><b>Tier 1</b>: User spending is from RM50 to RM199</li>
                                        <li><b>Tier 2</b>: User spending is RM200 and above</li>
                                    </ul>
                                </Tooltip>
                            }
                        >
                            <span>Tier</span>
                        </OverlayTrigger>
                    ),
                    field: "tier",
                    sort: "asc"
                },
                {
                    label: "Referrer",
                    field: "referrer",
                    sort: "asc"
                },
                {
                    label: "Referrals",
                    field: "referrals",
                    sort: "asc"
                },
                {
                    label: (
                        <OverlayTrigger
                            placement="top"
                            overlay={
                                <Tooltip>
                                    Number of transactions for last 7 days
                                </Tooltip>
                            }
                        >
                            <span>Number of Usage (in week)</span>
                        </OverlayTrigger>
                    ),
                    field: "weekUsage",
                    sort: "asc"
                },
                {
                    label: (
                        <OverlayTrigger
                            placement="top"
                            overlay={
                                <Tooltip>
                                    Number of transactions for last 1 month
                                </Tooltip>
                            }
                        >
                            <span>Number of Usage (in month)</span>
                        </OverlayTrigger>
                    ),
                    field: "monthUsage",
                    sort: "asc"
                },
                {
                    label: (
                        <OverlayTrigger
                            placement="top"
                            overlay={
                                <Tooltip>
                                    Total amount spent in all the transactions
                                </Tooltip>
                            }
                        >
                            <span>Total Spent (RM)</span>
                        </OverlayTrigger>
                    ),
                    field: "totalSpent",
                    sort: "asc"
                },
                {
                    label: (
                        <OverlayTrigger
                            placement="top"
                            overlay={
                                <Tooltip>
                                    Total number of e-Token spent in all the transactions
                                </Tooltip>
                            }
                        >
                            <span>e-Token Spent</span>
                        </OverlayTrigger>
                    ),
                    field: "tokenSpent",
                    sort: "asc"
                },
                {
                    label: "Last Transaction Date",
                    field: "lastTransaction",
                    sort: "asc"
                },
                {
                    label: (
                        <OverlayTrigger
                            placement="top"
                            overlay={
                                <Tooltip>
                                    Number of vouchers collected
                                </Tooltip>
                            }
                        >
                            <span>Voucher Collected</span>
                        </OverlayTrigger>
                    ),
                    field: "voucherAcquired",
                    sort: "asc"
                },
                {
                    label: (
                        <OverlayTrigger
                            placement="top"
                            overlay={
                                <Tooltip>
                                    Number of vouchers used
                                </Tooltip>
                            }
                        >
                            <span>Voucher Spent</span>
                        </OverlayTrigger>
                    ),
                    field: "voucherUsed",
                    sort: "asc"
                },
                {
                    label: (
                        <OverlayTrigger
                            placement="top"
                            overlay={
                                <Tooltip>
                                    Total number of washer machine transactions
                                </Tooltip>
                            }
                        >
                            <span>Washer Used</span>
                        </OverlayTrigger>
                    ),
                    field: "washerUsed",
                    sort: "asc"
                },
                {
                    label: (
                        <OverlayTrigger
                            placement="top"
                            overlay={
                                <Tooltip>
                                    Total number of dryer machine transactions
                                </Tooltip>
                            }
                        >
                            <span>Dryer Used</span>
                        </OverlayTrigger>
                    ),
                    field: "dryerUsed",
                    sort: "asc"
                }
            ];

            csvData.headers = [
                { label: "Operator", key: "operatorName" },
                { label: "Name", key: "userName" },
                { label: "Number", key: "number" },
                { label: "Join Date", key: "joinedDate" },
                { label: "Member ID", key: "memberId" },
                { label: "Store", key: "outlet" },
                { label: "Channel", key: "channel" },
                { label: "Tier", key: "tier" },
                { label: "Referrer", key: "referrer" },
                { label: "Referrals", key: "referrals" },
                { label: "Number of Usage (in week)", key: "weekUsage" },
                { label: "Number of Usage (in month)", key: "monthUsage" },
                { label: "Total Spent (RM)", key: "totalSpent" },
                { label: "e-Token Spent", key: "tokenSpent" },
                { label: "Last Transaction Date", key: "lastTransaction" },
                { label: "Voucher Collected", key: "voucherAcquired" },
                { label: "Voucher Spent", key: "voucherUsed" },
                { label: "Washer Used", key: "washerUsed" },
                { label: "Dryer Used", key: "dryerUsed" },
            ]
        }

        if (this.props.distributor.stamp) {
            data.columns.push({
                label: (
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip>
                                Total number of stamps collected
                            </Tooltip>
                        }
                    >
                        <span>Total Stamps</span>
                    </OverlayTrigger>
                ),
                field: "totalStamps",
                sort: "asc"
            })

            csvData.headers.push({ label: "Total Stamps", key: "totalStamps" })
        }

        return (
            <div className="admin-page-container">
                <Sidebar toggled={this.state.toggled} setToggled={this.handleToggle} />
                <div className="admin-page">
                    <Topbar handleToggle={this.handleToggle} />
                    <div className="admin-content">
                        <div className="card">
                            <div className="card-header">
                                <h5 className="card-title">User Performance</h5>
                            </div>

                            <div className="card-body">
                                <div className="mb-5">
                                    <h6>Filter</h6>
                                    {/* <div>
                                        <label htmlFor="operatorId">Select Operator: </label>
                                        <select id="operatorId" name="operatorId" className="browser-default form-select" value={this.state.operatorId} onChange={this.handleChange}>
                                            <option disabled value="">Select Operator</option>
                                            {
                                                this.props.distributor.admin.map(admin => <option key={admin.id} value={admin.id}>{admin.username}</option>)
                                            }
                                        </select>
                                    </div> */}

                                    <div>
                                        <label htmlFor="date">Select Date: </label>
                                        <DatePicker value={`${this.state.startDate ? new Date(this.state.startDate).toLocaleDateString() : ""} - ${this.state.endDate ? new Date(this.state.endDate).toLocaleDateString() : ""}`} onChange={this.handleDate} startDate={this.state.startDate} endDate={this.state.endDate} selectsRange shouldCloseOnSelect={false} />
                                    </div>

                                    <div className="d-flex">
                                        <button onClick={this.handleFilter} className="btn btn-primary btn-inline form-control me-3">
                                            Filter
                                        </button>
                                        <button onClick={this.handleReset} className="btn btn-secondary btn-inline form-control ms-3">
                                            Reset
                                        </button>
                                    </div>
                                </div>
                                <div className="text-center mt-5">{this.state.loading ? <Loading /> : (
                                    <div>
                                        <MDBDataTable data={data} noBottomColumns striped hover responsive bordered />
                                        <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                                            <CSVLink className="btn btn-primary" data={csvData.data} headers={csvData.headers} filename="userPerformance.csv" target="_blank">
                                                Download Report
                                            </CSVLink>
                                        </div>
                                    </div>
                                )}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        distributor: state.distributor.distributor,
        token: state.distributor.token
    };
};

export default connect(mapStateToProps, null)(UserPerformance);
